import { useEpocusMyProgramMembershipQuery } from "./__generated__/epocus-program-membership-operations.gql";

export const useHasEpocusProgram = (): {
  hasProgram: boolean;
  loading: boolean;
} => {
  const { data, loading, error } = useEpocusMyProgramMembershipQuery({
    variables: { input: { limit: 1 } },
    fetchPolicy: "cache-and-network",
  });

  const documents = data?.pullMyEpocusPrograms?.documents;

  if (documents !== undefined && documents.length > 0) {
    return { hasProgram: true, loading: false };
  }

  if (loading) return { hasProgram: false, loading: true };

  return {
    hasProgram: documents === undefined || error !== undefined,
    loading: false,
  };
};
